// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__r5Nz7","Label":"Input_Label__1njyU","InputElement":"Input_InputElement__3AlXO","Invalid":"Input_Invalid__1Ynm5"};